export default __webpack_public_path__ + "static/media/Fassung_AO2.42415245.png";